import moment from 'moment';

export const DESC = 0;
export const ASC = 1;

export const sortByDate = (a, b, order = DESC, field = 'date') => (
  order === DESC ? moment(b[field]).diff(moment(a[field])) : moment(a[field]).diff(moment(b[field]))
);
